import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";

export default function AppointmentDialog({
  open,
  onOpenChange,
  editing,
  form,
  setForm,
  clients,
  onSave,
}) {
  const update = (key, value) => setForm({ ...form, [key]: value });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="bg-[#171717] border-[#262626] text-white max-w-md"
        data-testid="appointment-dialog"
      >
        <DialogHeader>
          <DialogTitle
            className="font-bold tracking-tight uppercase"
            style={{ fontFamily: "Barlow Condensed, sans-serif" }}
          >
            {editing ? "MODIFICA APPUNTAMENTO" : "NUOVO APPUNTAMENTO"}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div>
            <Label className="text-zinc-400 text-xs uppercase tracking-wider">Titolo</Label>
            <Input
              value={form.title}
              onChange={(e) => update("title", e.target.value)}
              placeholder="es. Sessione allenamento"
              className="mt-1 bg-[#0A0A0A] border-[#262626] text-white"
              data-testid="appointment-title"
            />
          </div>
          <div>
            <Label className="text-zinc-400 text-xs uppercase tracking-wider">Tipo</Label>
            <Select
              value={form.appointment_type}
              onValueChange={(v) => update("appointment_type", v)}
            >
              <SelectTrigger
                className="mt-1 bg-[#0A0A0A] border-[#262626] text-white"
                data-testid="appointment-type"
              >
                <SelectValue />
              </SelectTrigger>
              <SelectContent className="bg-[#171717] border-[#262626]">
                <SelectItem value="appuntamento" className="text-white">Appuntamento</SelectItem>
                <SelectItem value="check" className="text-white">Check-in</SelectItem>
                <SelectItem value="valutazione" className="text-white">Valutazione</SelectItem>
                <SelectItem value="prova" className="text-white">Prova gratuita</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label className="text-zinc-400 text-xs uppercase tracking-wider">Cliente</Label>
            <Select
              value={form.client_id || "none"}
              onValueChange={(v) => update("client_id", v === "none" ? "" : v)}
            >
              <SelectTrigger
                className="mt-1 bg-[#0A0A0A] border-[#262626] text-white"
                data-testid="appointment-client"
              >
                <SelectValue placeholder="Nessun cliente" />
              </SelectTrigger>
              <SelectContent className="bg-[#171717] border-[#262626]">
                <SelectItem value="none" className="text-white">Nessun cliente</SelectItem>
                {clients.map((c) => (
                  <SelectItem key={c.id} value={c.id} className="text-white">
                    {c.first_name} {c.last_name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label className="text-zinc-400 text-xs uppercase tracking-wider">Data</Label>
            <Input
              type="date"
              value={form.date}
              onChange={(e) => update("date", e.target.value)}
              className="mt-1 bg-[#0A0A0A] border-[#262626] text-white"
              data-testid="appointment-date"
            />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <Label className="text-zinc-400 text-xs uppercase tracking-wider">Ora inizio</Label>
              <Input
                type="time"
                value={form.time_start}
                onChange={(e) => update("time_start", e.target.value)}
                className="mt-1 bg-[#0A0A0A] border-[#262626] text-white"
                data-testid="appointment-time-start"
              />
            </div>
            <div>
              <Label className="text-zinc-400 text-xs uppercase tracking-wider">Ora fine</Label>
              <Input
                type="time"
                value={form.time_end}
                onChange={(e) => update("time_end", e.target.value)}
                className="mt-1 bg-[#0A0A0A] border-[#262626] text-white"
                data-testid="appointment-time-end"
              />
            </div>
          </div>
          <div>
            <Label className="text-zinc-400 text-xs uppercase tracking-wider">Note</Label>
            <Textarea
              value={form.notes}
              onChange={(e) => update("notes", e.target.value)}
              className="mt-1 bg-[#0A0A0A] border-[#262626] text-white min-h-[60px] resize-none"
              data-testid="appointment-notes"
            />
          </div>
        </div>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            className="border-[#262626] text-zinc-300 hover:bg-[#1A1A1A]"
            data-testid="appointment-cancel"
          >
            Annulla
          </Button>
          <Button
            onClick={onSave}
            className="bg-[#007AFF] hover:bg-[#3395FF] text-white"
            data-testid="appointment-save"
          >
            {editing ? "Aggiorna" : "Crea"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
